import React from 'react';
import * as Styles from './FormContent.styles';
import withErrorBoundary from '@/utils/errorBoundary';
import useLocale from '@/hooks/useLocale/useLocale';
import {
  SelectField,
  TextField,
  Button,
  IconLoading,
  IconInfo,
  IconCheckBg,
  Skeleton,
} from 'gatorcomponents';

const FormContent = ({
  handleRedirectToSupportPage,
  title,
  handleSubmit,
  enabledButton,
  productsListToSelect,
  state,
  dispatchForm,
  serviceOptions,
  shouldRenderTicketService,
  isLoading,
  hasFormBeenCompleted,
  testId,
}) => {
  const { ticket: { forms: { gatorResolve } = {} } = {} } = useLocale();
  const {
    message,
    ticketId,
    selectedProduct,
    selectedService,
    errors,
  } = state;

  if (isLoading) {
    return (
      <Styles.Container data-testid={`${testId}-content`}>
        <Styles.Loading data-testid={`${testId}-content-loading`}>
          <IconLoading />
          <Styles.WaitingText>{gatorResolve.loadingLayout.waitingText}</Styles.WaitingText>
        </Styles.Loading>
      </Styles.Container>
    );
  }

  if (hasFormBeenCompleted) {
    return (
      <Styles.Container data-testid={`${testId}-content`}>
        <Styles.FormSubmitCompletedLayout data-testid={`${testId}-finished`}>
          <IconCheckBg secondaryColor="activePure" size="xl" />
          <Styles.WrapperDescriptionItems>
            <Styles.FormSubmitCompletedLayoutTitle>{gatorResolve.completedLayout.title}</Styles.FormSubmitCompletedLayoutTitle>
            <Styles.FormSubmitCompletedLayoutSubTitle>{gatorResolve.completedLayout.description}</Styles.FormSubmitCompletedLayoutSubTitle>
          </Styles.WrapperDescriptionItems>
          <Button
            label={gatorResolve.completedLayout.goBackButton}
            onClick={handleRedirectToSupportPage}
          />
        </Styles.FormSubmitCompletedLayout>
      </Styles.Container>
    );
  }

  return (
    <Styles.Container data-testid={`${testId}-content`}>
      <Styles.ContentWrapper>
        <Styles.Details>
          <Styles.Title>
            {title}
          </Styles.Title>
          <Styles.HelperText>
            {gatorResolve.description}
            <Styles.HelperTextHighlight>
              {gatorResolve.subDescription}
            </Styles.HelperTextHighlight>
          </Styles.HelperText>
          <Styles.Hint>
            <Styles.WrapperIconInfo>
              <IconInfo color="primaryDark" />
            </Styles.WrapperIconInfo>
            <Styles.HintContent>
              <Styles.HintContentDescription>{gatorResolve.hintTexts.main}</Styles.HintContentDescription>
              <Styles.HintContentDescription>
                {gatorResolve.hintTexts.messageStart}
                <Styles.HintContentDescriptionHighlight>
                  {gatorResolve.hintTexts.messageHighlight}
                </Styles.HintContentDescriptionHighlight>
                {gatorResolve.hintTexts.messageEnd}
              </Styles.HintContentDescription>
            </Styles.HintContent>
          </Styles.Hint>
          <Styles.HelperText>
            {gatorResolve.fillTheFormText}
          </Styles.HelperText>
        </Styles.Details>
        <Styles.Form onSubmit={e => handleSubmit(e)}>
          <Styles.FieldWrapper>
            <Styles.Label>{gatorResolve.form.domain.label}</Styles.Label>
            {productsListToSelect.length === 0 ? <Skeleton variant="input" /> : (
              <SelectField
                withScroll
                testId={`${testId}-select-products`}
                key="select-products"
                error={errors.selectedProduct.value}
                errorMessage={errors.selectedProduct.value ? gatorResolve.form.errors.selectedProduct.text : undefined}
                placeholder={gatorResolve.form.domain.placeholder}
                options={productsListToSelect.length > 0 ? productsListToSelect : [{ label: 'Carregando...', value: 'loading', title: true }]}
                value={selectedProduct.label}
                onClickSelect={option => dispatchForm({ type: 'SET_SELECTED_PRODUCT', payload: option })}
              />
            )}
          </Styles.FieldWrapper>
          <Styles.FieldWrapper>
            <Styles.Label>{gatorResolve.form.service.label}</Styles.Label>
            <SelectField
              withScroll
              testId={`${testId}-select-services`}
              key="select-services"
              error={errors.selectedService.value}
              errorMessage={errors.selectedService.value ? gatorResolve.form.errors.selectedService.text : undefined}
              placeholder={gatorResolve.form.service.placeholder}
              options={serviceOptions}
              value={selectedService.label}
              onClickSelect={option => dispatchForm({ type: 'SET_SELECTED_SERVICE', payload: option })}
            />
          </Styles.FieldWrapper>
          {shouldRenderTicketService && (
          <Styles.FieldWrapper>
            <Styles.Label>{gatorResolve.form.chat.label}</Styles.Label>
            <TextField
              testId={`${testId}-tickedId`}
              status={errors.ticketId.value ? 'error' : 'normal'}
              helpText={errors.ticketId.value ? gatorResolve.form.errors.ticketId.text : undefined}
              label={gatorResolve.form.chat.placeholder}
              value={ticketId}
              onChange={e => dispatchForm({ type: 'SET_TICKET_ID', payload: e.target.value })}
            />
          </Styles.FieldWrapper>
          )}
          <Styles.FieldWrapper>
            <Styles.Label>{gatorResolve.form.message.label}</Styles.Label>
            <TextField
              testId={`${testId}-message`}
              status={errors.message.value ? 'error' : 'normal'}
              helpText={errors.message.value ? gatorResolve.form.errors.message.text : ''}
              placeholder=""
              type="textarea"
              label={gatorResolve.form.message.placeholder}
              inputHeight={187}
              value={message}
              onChange={e => dispatchForm({ type: 'SET_MESSAGE', payload: e.target.value })}
            />
          </Styles.FieldWrapper>
          <Styles.WrapperButton>
            <Button
              type="submit"
              label={gatorResolve.form.buttons.submit}
              disabled={!enabledButton}
            />
          </Styles.WrapperButton>
        </Styles.Form>
      </Styles.ContentWrapper>
    </Styles.Container>
  );
};

export default withErrorBoundary(FormContent, 'FormContent');
